export default __webpack_public_path__ + "static/media/company_registration.bd63d66f.png";